import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../static/index/image-top/index-bg.png';
import _imports_1 from '../../static/index/content-1/7.png';
import _imports_2 from '../../static/common/close.png';
import _imports_3 from '../../static/common/mp-code.png';

const _withScopeId = n => (_pushScopeId("data-v-dd6d7762"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "index-box header-top"
};
const _hoisted_2 = {
  class: "index-box-content"
};
const _hoisted_3 = {
  class: "content-top-image"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "image",
  src: _imports_0
}, null, -1));

const _hoisted_5 = {
  class: "title-box"
};
const _hoisted_6 = {
  class: "title wow slideInRight"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des wow slideInLeft"
}, "跑腿+校园信息全方位校园服务平台", -1));

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line wow slideInLeft"
}, null, -1));

const _hoisted_9 = {
  class: "content-1-box"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title wow fadeInDown"
}, "产品介绍", -1));

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "detail wow fadeInDown"
}, "搭建平台整合校园周边资源，为师生提供综合性服务", -1));

const _hoisted_12 = {
  class: "des wow bounceInRight"
};
const _hoisted_13 = {
  class: "fun"
};
const _hoisted_14 = {
  class: "fun-left"
};
const _hoisted_15 = ["data-wow-delay"];
const _hoisted_16 = ["alt", "src"];
const _hoisted_17 = {
  class: "fun-left_item__name"
};

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fun-right wow flipInY"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "fun-right_image",
  src: _imports_1
})], -1));

const _hoisted_19 = {
  class: "content-2-box"
};

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title wow bounceInLeft"
}, "满足你校园里各种碎片化需求", -1));

const _hoisted_21 = {
  class: "content-2-box_content"
};

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title wow bounceInLeft"
}, "三大运营场景", -1));

const _hoisted_23 = {
  class: "content-2-box_content__scene"
};
const _hoisted_24 = ["data-wow-delay"];
const _hoisted_25 = ["alt", "src"];

const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-yellow"
}, null, -1));

const _hoisted_27 = {
  class: "name"
};

const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-black"
}, null, -1));

const _hoisted_29 = {
  class: "des"
};
const _hoisted_30 = {
  class: "content-3-box"
};

const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title wow fadeInUp"
}, "深挖校园市场，提供多种运营方式", -1));

const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des wow fadeInUp"
}, "在对的时间找对的人", -1));

const _hoisted_33 = {
  class: "content"
};
const _hoisted_34 = ["data-wow-delay"];
const _hoisted_35 = {
  class: "item-title"
};
const _hoisted_36 = {
  class: "item-bottom"
};
const _hoisted_37 = ["alt", "src"];
const _hoisted_38 = {
  class: "des"
};
const _hoisted_39 = {
  class: "content-4-box"
};

const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title wow rotateInDownLeft"
}, "深挖校园市场，提供多种运营方式", -1));

const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "detail wow rotateInDownLeft"
}, "5年运营开发经验", -1));

const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des wow rotateInDownLeft"
}, "5年数十所高校运营经验，提供全程精细化解决方案", -1));

const _hoisted_43 = {
  class: "content"
};
const _hoisted_44 = ["data-wow-delay"];
const _hoisted_45 = ["alt", "src"];
const _hoisted_46 = {
  class: "item-title"
};
const _hoisted_47 = {
  class: "item-des"
};
const _hoisted_48 = {
  class: "header"
};

const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: "",
  class: "image",
  src: _imports_3
}), /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, " 扫码关注公众号了解更多 ")], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Header = _resolveComponent("Header");

  const _component_Footer = _resolveComponent("Footer");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Header, {
    activeIndex: 0,
    onClickHeader1: _ctx.header1,
    onClickHeader2: _ctx.header2,
    siteInfo: $data.siteInfo
  }, null, 8, ["onClickHeader1", "onClickHeader2", "siteInfo"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString($data.siteInfo.title), 1), _hoisted_7, _hoisted_8])]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _hoisted_11, _createElementVNode("div", _hoisted_12, _toDisplayString($data.siteInfo.title) + "是一个面向高校市场的校园共享经济生活服务平台。学生可以通过平台叫跑腿、找人代取快递、发布跑腿办事需 求、发布技能服务需求等等，平台限制最低服务费，用户也可以额外增加赏金，只要你能想到的校园内的生活需求统统可 以在" + _toDisplayString($data.siteInfo.title) + "平台上发布。 ", 1), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.funLeftList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      "data-wow-delay": index * 0.05 + 's',
      class: "fun-left_item wow fadeInUp"
    }, [_createElementVNode("img", {
      alt: item.name,
      src: item.image,
      class: "fun-left_item__image"
    }, null, 8, _hoisted_16), _createElementVNode("div", _hoisted_17, _toDisplayString(item.name), 1)], 8, _hoisted_15);
  }), 128))]), _hoisted_18])]), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.sceneList, (scene, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      "data-wow-delay": index * 0.1 + 's',
      class: "scene-item wow zoomInDown"
    }, [_createElementVNode("img", {
      alt: scene.name,
      src: scene.image,
      class: "image"
    }, null, 8, _hoisted_25), _hoisted_26, _createElementVNode("div", _hoisted_27, _toDisplayString(scene.name), 1), _hoisted_28, _createElementVNode("div", _hoisted_29, _toDisplayString(scene.des), 1)], 8, _hoisted_24);
  }), 128))])])]), _createElementVNode("div", _hoisted_30, [_hoisted_31, _hoisted_32, _createElementVNode("div", _hoisted_33, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.schoolBazaarList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      "data-wow-delay": index * 0.05 + 's',
      class: "content-item wow fadeInUp"
    }, [_createElementVNode("div", _hoisted_35, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_36, [_createElementVNode("img", {
      alt: item.name,
      src: item.image,
      class: "image"
    }, null, 8, _hoisted_37), _createElementVNode("div", _hoisted_38, _toDisplayString(item.des), 1)])], 8, _hoisted_34);
  }), 128))])]), _createElementVNode("div", _hoisted_39, [_hoisted_40, _hoisted_41, _hoisted_42, _createElementVNode("div", _hoisted_43, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.selectDXList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      "data-wow-delay": index * 0.05 + 's',
      class: "content-item wow rotateInDownLeft"
    }, [_createElementVNode("img", {
      alt: item.name,
      src: item.image,
      class: "image"
    }, null, 8, _hoisted_45), _createElementVNode("div", _hoisted_46, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_47, _toDisplayString(item.des), 1)], 8, _hoisted_44);
  }), 128))])])]), _createVNode(_component_Footer, {
    siteInfo: $data.siteInfo
  }, null, 8, ["siteInfo"]), $data.dialogVisible ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "diy-dialog-box",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.hideDialog && $options.hideDialog(...args))
  }, [_createElementVNode("div", {
    class: "diy-dialog-box-centent wow zoomIn",
    "data-wow-duration": "0.3s",
    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
  }, [_createElementVNode("div", _hoisted_48, [_createElementVNode("img", {
    alt: "",
    class: "close-image",
    src: _imports_2,
    onClick: _cache[0] || (_cache[0] = (...args) => $options.hideDialog && $options.hideDialog(...args))
  })]), _hoisted_49])])) : _createCommentVNode("", true)]);
}